export enum CURRENCY {
    EUR = '€',
}
// TODO: unit testing move rest of the enums from main.ts so we can mock constants without destroying enums
